export var SapSourceStatus;
(function (SapSourceStatus) {
    SapSourceStatus["SAP_SOURCE_STATUS_REGISTERED"] = "REGISTERED";
    SapSourceStatus["SAP_SOURCE_STATUS_DISCOVERING"] = "DISCOVERING";
    SapSourceStatus["SAP_SOURCE_STATUS_READY"] = "READY";
    SapSourceStatus["SAP_SOURCE_STATUS_BULK_LOADING"] = "BULK_LOADING";
    SapSourceStatus["SAP_SOURCE_STATUS_STREAMING"] = "STREAMING";
    SapSourceStatus["SAP_SOURCE_STATUS_COMPLETED"] = "COMPLETED";
    SapSourceStatus["SAP_SOURCE_STATUS_PAUSED"] = "PAUSED";
    SapSourceStatus["SAP_SOURCE_STATUS_FAILED"] = "FAILED";
})(SapSourceStatus || (SapSourceStatus = {}));
